export enum UserOnlineStateStatusDto {
    Offline = 'Offline',
    Online = 'Online',
}
